/**
 * Tiny inline SVG sparkline for KPI cards. Values are scaled to the local
 * max; a flat zero series renders a baseline.
 */
export function MiniSparkline({
    values,
    width = 96,
    height = 28,
    stroke = 'var(--chart-1)',
}: {
    readonly values: Array<number>;
    readonly width?: number;
    readonly height?: number;
    readonly stroke?: string;
}) {
    if (values.length < 2) {
        return null;
    }
    const max = Math.max(...values, 1);
    const stepX = width / (values.length - 1);
    const points = values
        .map((value, index) => {
            const x = index * stepX;
            const y = height - 2 - (value / max) * (height - 4);
            return `${x.toFixed(1)},${y.toFixed(1)}`;
        })
        .join(' ');
    return (
        <svg
            width={width}
            height={height}
            viewBox={`0 0 ${width} ${height}`}
            aria-hidden="true"
            className="overflow-visible"
        >
            <polyline
                points={points}
                fill="none"
                stroke={stroke}
                strokeWidth={1.5}
                strokeLinejoin="round"
                strokeLinecap="round"
            />
        </svg>
    );
}
